var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#F7E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9993 19.166C36.5651 19.166 38.0957 19.6303 39.3976 20.5002C40.6995 21.3701 41.7142 22.6065 42.3134 24.0531C42.9126 25.4997 43.0694 27.0915 42.7639 28.6271C42.4584 30.1628 41.7044 31.5734 40.5973 32.6806C39.4901 33.7878 38.0795 34.5418 36.5438 34.8472C35.0081 35.1527 33.4164 34.9959 31.9698 34.3967C30.5232 33.7975 29.2868 32.7828 28.4169 31.4809C27.547 30.1791 27.0827 28.6485 27.0827 27.0827L27.0906 26.7391C27.1791 24.701 28.0511 22.7757 29.5245 21.3647C30.998 19.9538 32.9593 19.1661 34.9993 19.166ZM38.166 38.166C40.2656 38.166 42.2793 39.0001 43.7639 40.4848C45.2486 41.9694 46.0827 43.9831 46.0827 46.0827V47.666C46.0827 48.5059 45.7491 49.3113 45.1552 49.9052C44.5613 50.4991 43.7559 50.8327 42.916 50.8327H27.0827C26.2428 50.8327 25.4374 50.4991 24.8435 49.9052C24.2496 49.3113 23.916 48.5059 23.916 47.666V46.0827C23.916 43.9831 24.7501 41.9694 26.2348 40.4848C27.7194 39.0001 29.7331 38.166 31.8327 38.166H38.166Z",
    fill: "#935FAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicant);
export default __webpack_public_path__ + "static/media/applicant.553815fe030ea36cba916708a67aa55e.svg";
export { ForwardRef as ReactComponent };